import {
    action,
    observable,
    makeObservable,
    runInAction,
    computed,
} from "mobx";
import api from "../../../api";
// import { CheckboxValueType } from "antd/es/checkbox/Group";
import {DatePickerProps, Modal, message} from "antd";
import {RangePickerProps} from "antd/es/date-picker";
import CommonStore from "../common_store";
import axios from "axios";

class VideoListStore {
    @observable messageTemplate: boolean = false;
    @observable operateStatus: string = "";
    @observable videoUrl: string = "";
    @observable duration: any = null;
    // @observable accountNo: string = "";
    //搜索表单字段
    @observable searchForm: powerSearchData = {isEnable: true};
    @observable tableData: any = {};
    //表格加载状态
    @observable tableLoad: boolean = true;
    //分页信息
    @observable pageData: IPageData = {
        page: 1,
        size: 10,
        changePage: (page: number, size: number) => {
            runInAction(() => {
                this.pageData.page = page;
                this.pageData.size = size;
                this.pageData = {...this.pageData};
            });
            this.getVideoPage();
        },
    };
    //视频文件
    @observable formData: any = null;
    //是否上传视频文件
    @observable approval: boolean = false;
    //点击编辑框传值
    @observable lookPower: any = {priority: 'NORMAL'};
    //编辑框控制字段
    @observable addOrUpdateModal: IModal2 = {
        title: "",
        message: false,
        upload: false,
        update: false,
        uploadTest: false,
        updateModalType: (type: "message" | "upload" | "update" | 'uploadTest') => {
        },
        get isOpen(): boolean {
            return this.message || this.upload || this.update || this.uploadTest;
        },
        open: (type: "message" | "upload" | "update" | 'uploadTest', record: any) => {
            if (type === "message") {
                runInAction(() => {
                    this.addOrUpdateModal.title = "挂机短信配置";
                    this.addOrUpdateModal.message = true;
                    this.addOrUpdateModal.upload = false;
                    this.addOrUpdateModal.update = false;
                    this.addOrUpdateModal.uploadTest = false;
                });
            } else if (type === "upload") {
                this.addOrUpdateModal.title = "视频上传";
                runInAction(() => {
                    this.addOrUpdateModal.message = false;
                    this.addOrUpdateModal.upload = true;
                    this.addOrUpdateModal.update = false;
                    this.addOrUpdateModal.uploadTest = false;
                });
            } else if (type === "uploadTest") {
                this.addOrUpdateModal.title = "视频上传test";
                runInAction(() => {
                    this.addOrUpdateModal.message = false;
                    this.addOrUpdateModal.uploadTest = true;
                    this.addOrUpdateModal.upload = false;
                    this.addOrUpdateModal.update = false;
                });
            } else if (type === "update") {
                this.addOrUpdateModal.title = "编辑";
                runInAction(() => {
                    this.addOrUpdateModal.message = false;
                    this.addOrUpdateModal.uploadTest = false;
                    this.addOrUpdateModal.upload = false;
                    this.addOrUpdateModal.update = true;
                    this.lookPower = {...record};
                });
            }
        },
        close: () => {
            runInAction(() => {
                this.addOrUpdateModal.message = false;
                this.addOrUpdateModal.uploadTest = false;
                this.addOrUpdateModal.upload = false;
                this.addOrUpdateModal.update = false;
                this.lookPower = {};
            });
        },
    };
    //上传视频文件地址
    @observable uploadVideoUrl: any = {};
    @observable newUploadVideoUrl: any = {};

    commonStore: CommonStore;

    constructor(baseStore: CommonStore) {
        this.commonStore = baseStore;
        makeObservable(this);
    }

    setSearchForm(obj: powerSearchData) {
        runInAction(() => {
            this.searchForm = obj;
        });
    }

    //重置分页
    resetPage() {
        runInAction(() => {
            this.pageData.page = 1;
        });
    }

    @action
    getVideoPage() {
        runInAction(() => {
            this.tableData = {};
            this.tableLoad = true;
        });
        const data = {...this.searchForm};
        data.size = this.pageData.size;
        data.page = this.pageData.page;
        api.videoListApi
            .getVideoPage(data)
            .then((res: any) => {
                if (res.code == 200) {
                    runInAction(() => {
                        this.tableData = res.data;
                        this.tableData = {...this.tableData};
                        this.tableLoad = false;
                    });
                    this.commonStore.getPagePermission("video_management");
                }
            })
            .catch((e: any) => {
                runInAction(() => {
                    this.tableLoad = false;
                });
            });
    }

    setLookPower(obj: any) {
        runInAction(() => {
            this.lookPower = obj;
        });
    }

    @action
    onChangeMessage(checked: boolean) {
        console.log(`switch to ${checked}`);
        runInAction(() => {
            this.messageTemplate = checked;
        });
    }

    //获取临时上传地址
    @action
    getUploadVideoUrl(info: any, videoTag: string) {
        api.videoListApi
            .getUploadVideoUrl({fileName: info.file.name})
            .then(async (res: any) => {
                console.log(res.data);
                runInAction(() => {
                    this.uploadVideoUrl = res.data;
                });
                this.uploadFile(info, this.uploadVideoUrl.urlPath, videoTag);
            })
            .catch((err: any) => {
            });
    }


    //临时上传到临时地址
    uploadFile(info: any, url: any, videoTag: string) {
        console.log("url", url, info);
        // const formData = new FormData();
        // formData.append("file", info.file as any);
        // console.log("formData", formData, info.file.name);
        axios
            .put(url, info.file, {
                headers: {
                    "Content-Type": "video/mp4",
                    // 'Content-Type': 'application/octet-stream'
                },
                withCredentials: false,
            }).then(response => {
        }).catch((err) => {
        })

        api.videoListApi
            .videoUpload({
                objectName: this.uploadVideoUrl.objectName,
                fileName: info.file.name,
            }, videoTag)
            .then(async (res: any) => {
                runInAction(() => {
                    this.approval = false;
                });
                this.getVideoPage();
                this.resetPage();
            })
            .catch((e: any) => {
            });
    }

    //提交上传视频
    @action
    uploadVideo(videoTag: string, info: any) {
        this.addOrUpdateModal.close();
        this.getUploadVideoUrl(info, videoTag); //获取临时上传地址
    }

    @action
    newUploadVideo(priority: string, videoTag: string, info: any) {
        this.addOrUpdateModal.close();
        api.videoListApi
            .getUploadVideoUrl({fileName: info.file.name})
            .then(async (res: any) => {
                console.log(res.data);
                runInAction(() => {
                    this.uploadVideoUrl = res.data;
                });
                this.newUploadFile(info, this.uploadVideoUrl.urlPath, videoTag, priority);
            })
            .catch((err: any) => {
            });
        // this.addOrUpdateModal.close();
        // const reqId = Date.now().toString();
        // let P1 = api.videoListApi.getUploadVideoUrl({fileName: info.file.name, reqId})
        // let P2 = api.videoListApi.getNewUploadVideoUrl({fileName: info.file.name, reqId,type:'video'})
        // Promise.all([P1, P2])
        //     .then((values) => {
        //         console.log(values);
        //         this.uploadVideoUrl = values[0]?.data;
        //         this.newUploadVideoUrl = values[1]?.data;
        //         this.newUploadFile(info, this.uploadVideoUrl.urlPath, this.newUploadVideoUrl, videoTag, reqId, priority);
        //     }).catch((err: any) => {
        // });
    }

    async newUploadFile(info: any, url: any, videoTag: string, priority: string) {
        try {
            await axios.put(url, info.file, {
                headers: {"Content-Type": "video/mp4"},
                withCredentials: false,
            }).then(response => {}).catch((err) => {})
        } catch (e) {}
        api.videoListApi
            .videoUpload({
                objectName: this.uploadVideoUrl.objectName,
                fileName: info.file.name,
                priority
            }, videoTag)
            .then(async (res: any) => {
                runInAction(() => {
                    this.approval = false;
                });
                this.getVideoPage();
                this.resetPage();
            })
            .catch((e: any) => {
            });
    }

    @action
    deleteVideo(videoNo: string) {
        api.videoListApi
            .deleteVideo(videoNo)
            .then((res: any) => {
                message.success("删除成功");
                this.resetPage();
                this.getVideoPage();
            })
            .catch((e: any) => {
            });
    }

    deletePower(videoNo: string) {
        return new Promise((resolve, reject) => {
            Modal.confirm({
                centered: true,
                title: "确认删除",
                content: "您确定要删除该视频吗？",
                okText: "确认",
                cancelText: "取消",
                onOk: () => {
                    this.deleteVideo(videoNo);
                    return resolve(true);
                },
                onCancel: () => {
                    return false;
                },
            });
        });
    }

    @action
    downloadVideo(videoNo: string) {
        api.videoListApi
            .getVideoUrl(videoNo)
            .then(async (res: any) => {
                console.log(res.data);
                runInAction(() => {
                    this.videoUrl = res.data;
                });
                this.download(this.videoUrl, "test_video" + Date.now());
            })
            .catch((err: any) => {
            });
    }

    // 下载视频函数
    download(url: string, name: any) {
        fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
                const a = document.createElement("a");
                const objectUrl = window.URL.createObjectURL(blob);
                a.download = name;
                a.href = objectUrl;
                a.click();
                window.URL.revokeObjectURL(objectUrl);
                a.remove();
            });
    }

    @action
    updateVideoTag(data: any) {
        api.videoListApi
            .updateVideoTag(data.no, data)
            .then(async (res: any) => {
                this.getVideoPage();
                message.success("编辑成功");
                this.addOrUpdateModal.close();
            })
            .catch((err: any) => {
            });
    }

    @action
    videoOperate(record: any) {
        api.videoListApi
            .videoOperate({
                videoNo: record.no,
                operate: record.videoStatus === 1 ? 2 : 1,
            })
            .then((res: any) => {
                message.success(record.videoStatus === 1 ? "下架成功" : "上架成功");
                this.getVideoPage();
            })
            .catch((e: any) => {
            });
    }

    @action changeOperate(record: any) {
        this.operateStatus =
            record.videoStatus === 1
                ? "您确定要下架该视频吗？"
                : "您确定要上架该视频吗？";
        return new Promise((resolve, reject) => {
            Modal.confirm({
                centered: true,
                title: "确认上架/下架",
                content: this.operateStatus,
                okText: "确认",
                cancelText: "取消",
                onOk: () => {
                    this.videoOperate(record);
                    return resolve(true);
                },
                onCancel: () => {
                    return false;
                },
            });
        });
    }
}

export default VideoListStore;
